<template>
  <div class="mypooq-inner-wrap">
    <section>
      <div class="wrap">
        <div class="my-user-qna-info">
          <span class="cs-number" tabindex="0">1599-3709</span>
          <ul class="cs-meta-list" tabindex="0">
            <li>평일 09:00 – 점심시간 12:00-13:00</li>
            <li>주말 및 공휴일 휴무</li>
          </ul>
          <p>Wavve 서비스 이용 시 불편사항이나 문의사항을 1:1 문의로 보내주시면<br>신속하고 친절하게 안내해 드리겠습니다!</p>
          <a href="https://member.wavve.com/customer/qna/ask" class="link-inquiry">1:1 문의하기</a>
        </div>
      </div>
    </section>
    <section class="mypooq" v-if="dataQna">
      <div class="mypooq-info-body">
        <div class="wrap">
          <div class="my-qa-wrap">
            <h2 class="my-qa-tit" tabindex="0">나의 문의 내역</h2>
            <table class="my-qa-table">
              <caption class="blind">1:1문의</caption>
              <colgroup>
                <col style="width: 140px;">
                <col style="width: 140px;">
                <col>
                <col style="width: 140px;">
              </colgroup>
              <thead>
              <tr>
                <th>상태</th>
                <th>구분</th>
                <th><p class="al">제목</p></th>
                <th>등록일</th>
              </tr>
              </thead>

              <tbody>
              <tr>
                <td tabindex="0">{{ dataQna.status }}</td>
                <td>{{ dataQna.questiontype }}</td>
                <td><a href="#" class="al" tabindex="0">{{ dataQna.title }}</a></td>
                <td>{{ dataQna.regdate }}</td>
              </tr>
              </tbody>
            </table>

            <!-- 질문 영역 -->
            <div class="my-qa-q" tabindex="0">
              <template v-if="dataQna.name">이름 : {{ dataQna.name }}<br></template>
              <template v-if="dataQna.email">이메일 : {{ dataQna.email }}<br></template>
              <template v-if="dataQna.phone">연락처 : {{ dataQna.phone }} <br></template>
              <template v-if="dataQna.questiontype">질문구분: {{ dataQna.questiontype }}<br></template>
              <template v-if="dataQna.servicetype">서비스 구분 : {{ dataQna.servicetype }}<br></template>
              <template v-if="dataQna.programinfo">프로그램 정보 : {{ dataQna.programinfo }} <br></template>
              <template v-if="dataQna.env_1">사용환경1 : {{ dataQna.env_1 }}<br></template>
              <template v-if="dataQna.env_2">사용환경2 : {{ dataQna.env_2 }}<br></template>
              <div v-html="'내용 : ' + dataQna.contents"></div>
            </div>

            <!-- 답변 영역 -->
            <div v-if="dataQna && dataQna.answers && dataQna.answers.length" class="my-qa-a-wrap" tabindex="0">
              <div v-for="(answer, index) in dataQna.answers" class="my-qa-a" :key="'answer_'+ index">
                <span class="my-qa-a-tag">
                  <span :class="qnaStatusClass(answer.status)">{{answer.status}}</span>
                </span>
                <p class="my-qa-a-text" v-html="answer.answer"></p>
                <p class="my-qa-a-date">{{ answer.regdate }}</p>
              </div>
            </div>

            <button @click="clickDelete()" type="button" class="my-qa-delete">삭제</button>

            <!-- 목록 버튼 -->
            <div class="qa-go-list-btn">
              <a href="#" @click.prevent="goList()">
                <img src="../../assets/images/mypooq/icon-table-listback.png" alt="목록 아이콘">
                <span>목록</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { deleteUserQna, getUserQnaDetail } from '@/common/utils/request'
import constant from '@/common/resources/constant'
import queryString from '@/common/utils/querystring'
import { PATH_NAME_USER_QNA } from '@/common/resources/router.const'

export default {
  data () {
    return {
      qnaId: queryString.getQueryParamValue(this.$route, 'qnaid'),
      dataQna: undefined,
      currentPage: 1,
      pagingCnt: 10,
      limit: 10,
      totalCount: 0
    }
  },
  methods: {
    clickDelete () {
      if (confirm(constant.MSG_ASK_DELETE_USER_QNA)) {
        deleteUserQna({ qnaid: this.dataQna.qnaid }).then(() => {
          this.$router.push({ name: PATH_NAME_USER_QNA })
        })
      }
    },
    goList () {
      this.$router.push({ name: PATH_NAME_USER_QNA })
    },
    qnaStatusClass (status) {
      let className = 'badge ui'
      switch (status) {
        case '문의오류':
          className += ' negative'
          break
        case '처리중':
          className += ' warning'
          break
        case '답변완료':
          className += ' positive'
          break
      }
      return className
    }
  },
  created () {
    getUserQnaDetail({ qnaid: this.qnaId }).then(({ data }) => {
      this.dataQna = data
    })
  }
}
</script>
<style lang="scss" src="@/assets/scss/category/my.scss"></style>
